module.exports = __webpack_public_path__ + "media/images/signature-abc-ee9f05651433d79305d87f29324e7565.png";